import React, { PropTypes } from 'react';
import { Field } from 'redux-form';
import { CheckBoxField } from 'common/components/form_fields';
import AnimatedButton from 'common/components/animated_button';
import { ModalTrigger } from 'common/modal';

const CONFIRM_LABEL = `
  I have read and agree to these rules. I intend to participate in this project and
  promise to submit my very best, original work.
`;

const ReservationForm = ({
  handleSubmit, isReserving, disabled, isReserved, reserveError,
}) => {
  if (reserveError) {
    return (<div className="modal-actions">
      <p>
        <span className="tag tag-highlight danger tag-sm">
          There was an error trying to reserve your spot, please click below and try again.
        </span>
      </p>
      <button onClick={() => (window.location.reload())} className="btn btn-primary">
        Reload the Project
      </button>
    </div>);
  }

  return (<form onSubmit={handleSubmit}>
    <Field component={CheckBoxField} name="confirm" value="true" label={CONFIRM_LABEL} />
    <div className="modal-actions">
      {!isReserved && <AnimatedButton
        type="submit"
        label="Got It"
        disabled={disabled}
        className="btn btn-primary"
        processingLabel="Reserving..."
        processing={isReserving}
      />}
      <ModalTrigger className="btn btn-text" trigger="elite-reservation-modal">
        Cancel
      </ModalTrigger>
    </div>
  </form>);
};

ReservationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  reserveError: PropTypes.object,
  isReserving: PropTypes.bool,
  disabled: PropTypes.bool,
  isReserved: PropTypes.bool,
};

export default ReservationForm;



// WEBPACK FOOTER //
// ./project/components/reservation_form.jsx